export default "__VITE_ASSET__DlbgN48D__"